import { render, staticRenderFns } from "./ComponentLoader.vue?vue&type=template&id=a4ad3918&"
import script from "./ComponentLoader.vue?vue&type=script&lang=js&"
export * from "./ComponentLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports